import { render, staticRenderFns } from "./PostsList.vue?vue&type=template&id=e1e5de00&scoped=true"
import script from "./PostsList.vue?vue&type=script&lang=js"
export * from "./PostsList.vue?vue&type=script&lang=js"
import style0 from "./PostsList.vue?vue&type=style&index=0&id=e1e5de00&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e5de00",
  null
  
)

export default component.exports